import { render, staticRenderFns } from "./recuperarSenha.vue?vue&type=template&id=fa3e3654&scoped=true"
import script from "./recuperarSenha.vue?vue&type=script&lang=js"
export * from "./recuperarSenha.vue?vue&type=script&lang=js"
import style0 from "./recuperarSenha.vue?vue&type=style&index=0&id=fa3e3654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3e3654",
  null
  
)

export default component.exports